export default "__VITE_ASSET__C$BzELKJ__"